import { DodatkowyImportLokalizacjiModel } from "./dodatkowyImportLokalizacjiModel";

export class ImportujLokalizacjeModel extends DodatkowyImportLokalizacjiModel {
    czyNadpisac: boolean;
}